"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoneConnectionType = exports.FootPrintShapeType = exports.FootPrintPadShape = void 0;
var FootPrintPadShape;
(function (FootPrintPadShape) {
    FootPrintPadShape["circular"] = "circular";
    FootPrintPadShape["rectangle"] = "rectangle";
    FootPrintPadShape["obround"] = "obround";
    FootPrintPadShape["trapezoid"] = "trapezoid";
    FootPrintPadShape["ellipse"] = "ellipse";
    FootPrintPadShape["polygon"] = "polygon";
})(FootPrintPadShape || (exports.FootPrintPadShape = FootPrintPadShape = {}));
var FootPrintShapeType;
(function (FootPrintShapeType) {
    FootPrintShapeType["text"] = "text";
    FootPrintShapeType["line"] = "line";
    FootPrintShapeType["circle"] = "circle";
    FootPrintShapeType["arc"] = "arc";
    FootPrintShapeType["polygon"] = "polygon";
    FootPrintShapeType["model"] = "model";
})(FootPrintShapeType || (exports.FootPrintShapeType = FootPrintShapeType = {}));
var ZoneConnectionType;
(function (ZoneConnectionType) {
    ZoneConnectionType["padsNotCovered"] = "padsNotCovered";
    ZoneConnectionType["thermalRelief"] = "thermalRelief";
    ZoneConnectionType["padSolidInsideTheZone"] = "padSolidInsideTheZone";
    ZoneConnectionType["thermalReliefOnlyForThPads"] = "thermalReliefOnlyForThPads";
})(ZoneConnectionType || (exports.ZoneConnectionType = ZoneConnectionType = {}));
//# sourceMappingURL=footprint.js.map